export const REBUZZ_OPTION_PROPERTIES = {
  minPoints: 'minPoints',
  minCurrency: 'minCurrency',
  priceSettings: 'priceSettings',
  queueLength: 'queueLength',
  queuePeriodicity: 'queuePeriodicity',
  queueSettings: 'queueSettings',
  publish: 'publish',
  threadLength: 'threadLength',
};
